import { useLocation } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useState } from 'react';
import CheckoutForm from './CheckoutForm';
import ClientInfoForm from './ClientInfo/ClientInfoForm';
import PaymentConfirmation from './PaymentConfirmation/PaymentConfirmation';
import './Checkout.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function Checkout() {
  const { state } = useLocation();

  const plan = state?.plan || "Custom Package";
  const price = state?.price || 0;
  const features = state?.features || [];

  const [step, setStep] = useState(1); // 1 = client info, 2 = payment
  const [clientInfo, setClientInfo] = useState({
    name: '',
    email: '',
    business: '',
    goals: '',
    timeline: '',
  });

  const handleNext = () => {
    if (!clientInfo.name || !clientInfo.email) {
      alert("Please enter your name and email before continuing.");
      return;
    }

    setStep(2);
  };
  const handleBack = () => setStep(1);

return (
  <div className="checkout-container">
    {/* Only show this if not on the final step */}
    {step !== 3 && (
      <div className="bundle-details">
        <h2>{plan} Package Includes:</h2>
        <ul>
          {features?.map((item, idx) => {
            const label = typeof item === "string" ? item : item.label;
            const included = typeof item === "string" ? true : item.included;

            return (
              <li
                key={idx}
                style={{
                  opacity: included ? 1 : 0.55,
                  textDecoration: included ? "none" : "line-through",
                }}
              >
                {label}
              </li>
            );
          })}
        </ul>
      </div>
    )}

    <div className="checkout-form-wrapper">
      {step === 1 && (
        <>
          <ClientInfoForm
            clientInfo={clientInfo}
            setClientInfo={setClientInfo}
          />
          <button onClick={handleNext} className="next-button">
            Next: Payment
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <Elements stripe={stripePromise}>
            <CheckoutForm
              plan={plan}
              price={price}
              clientInfo={clientInfo}
              onSuccess={() => setStep(3)}
            />
          </Elements>
          <button onClick={handleBack} className="back-button">
            ← Back to Client Info
          </button>
        </>
      )}

      {step === 3 && <PaymentConfirmation />}
    </div>
  </div>
);

}

export default Checkout;
